import { useCallback } from "react";
import getDate from "date-fns/getDate";
import parseISO from "date-fns/parseISO";
import { AppointmentRescheduleDialogProps } from "../AppointmentRescheduleDialog";
import { Center } from "./types";
import { getMonthDayList } from "../../../common/dateHelpers";

const useRescheduleCalendar = (params: {
  selectedDate: Date | null;
  defaultCalendarMonth: Date;
  onDateChange: (date: Date | null) => void;
  onMonthChange: (date: Date) => void;
  isLoading: boolean;
  refetchCenterTimeSlots: (monthDate: Date) => Promise<void>;
  center: Center | null;
  statCutoffs?: Record<string, number>;
}): AppointmentRescheduleDialogProps["calendarProps"] => {
  const {
    selectedDate,
    defaultCalendarMonth,
    onDateChange,
    onMonthChange,
    isLoading,
    refetchCenterTimeSlots,
    center,
    statCutoffs,
  } = params;

  const allAvailableDays = getMonthDayList(selectedDate);

  const statUnavailableDays = new Set(
    Object.entries(statCutoffs ?? {})
      .filter(([, cutoff]) => cutoff <= 0)
      .map(([dateISO]) => getDate(parseISO(dateISO))),
  );

  const availableDays = allAvailableDays.filter(
    (d) => !statUnavailableDays.has(d),
  );

  const handleMonthChange = useCallback(
    async (date: Date) => {
      onMonthChange(date);
      await refetchCenterTimeSlots(date);
    },
    [onMonthChange, refetchCenterTimeSlots],
  );

  return {
    availableDays,
    value: selectedDate,
    defaultCalendarMonth,
    onChange: onDateChange,
    onMonthChange: handleMonthChange,
    onYearChange: handleMonthChange,
    loading: isLoading,
    maxDate: center?.dateLimits.maxCenterTimezone,
    views: ["month", "year", "day"],
  };
};

export default useRescheduleCalendar;
